import { render, staticRenderFns } from "./cabinet-fl223-notices-list.vue?vue&type=template&id=10fa244e&"
import script from "./cabinet-fl223-notices-list.vue?vue&type=script&lang=js&"
export * from "./cabinet-fl223-notices-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10fa244e')) {
      api.createRecord('10fa244e', component.options)
    } else {
      api.reload('10fa244e', component.options)
    }
    module.hot.accept("./cabinet-fl223-notices-list.vue?vue&type=template&id=10fa244e&", function () {
      api.rerender('10fa244e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/fl223/cabinet-fl223-notices-list.vue"
export default component.exports